import {
  HotelsRawEventName,
  type LinkToHotelProps,
  useLinkToHotel as useCoreLinkToHotel,
  useEmitCoreHotelsRawEvent,
} from "@b2bportal/core-hotels";
import { useLodgingLink } from "@tenant/hotels";

export const useLinkToHotel = (props: LinkToHotelProps) => {
  const stayType = props.hotel.stayType;

  const target = useLodgingLink(
    props.hotel.lodging.id,
    props.hotel.lodging.name,
    stayType
  );

  const { context, handlers } = useCoreLinkToHotel(props);

  const emitHotelMapCardTapped = useEmitCoreHotelsRawEvent(
    HotelsRawEventName.HotelMapCardTapped
  );

  const onClickHotelCard = () => {
    emitHotelMapCardTapped({
      properties: {
        hotelId: props.hotel.lodging.id,
      },
    });
  };

  return {
    context: {
      ...context,
      target,
      linkProps: {
        ...context.linkProps,
        onClick: onClickHotelCard,
      },
    },
    handlers,
  };
};
